import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGumroadComponent } from './simple-icons-gumroad.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGumroadComponent ],
    exports:      [ SimpleIconsGumroadComponent ],
    bootstrap:    []
})
export class SimpleIconsGumroadModule {}
